export default __webpack_public_path__ + "static/media/sandal13.16ae1b94.jpeg";